export default __webpack_public_path__ + "static/media/chevron-up.inline.c21144a6.svg";